<template>
<!-- I will see how you implement this page and after will spread the gray background -->
    <div>
        <div v-if="errorMessage.length">
            {{errorMessage}}
        </div>

        <div v-if="loaded">
            <div :id="displayType">

            <div class="tracker-section">
                <h2 class="tracker-name heading2">
                    <template v-if="!nameEditMode">
                        {{ info.name }}
                    </template>

                    <template v-else>
                        <input v-model="newName" v-on:keyup.enter="updateName" class="form-control">
                    </template>

                    <template v-if="canEditInfo">
                        <a v-if="!nameEditMode" @click="newName = info.name; nameEditMode = true" class="tracker-name__edit"></a>
                        <template v-else>
                            <div class="tracker-name__actions">
                                <a @click="updateName" class="tracker-name__actions__save"></a>
                                <a @click="nameEditMode = false" class="tracker-name__actions__cancel"></a>
                            </div>
                        </template>
                    </template>
                </h2>

                <b-form-checkbox v-if="hasPipeline" v-model="displayType" name="check-button" value="list" unchecked-value="pipeline" switch>
                </b-form-checkbox>

                <b-dropdown class="dropdown--secondary" variant="link" right toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <div class="team-section">
                            <p>
                                <span v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(info.permissions, 1)" :key="index">
                                    {{item}}
                                </span>
                            </p>

                            <div class="team-list">
                                <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(info.permissions)" :key="index" class="team-list__item">
                                    <img :src="avatar" style="width: 30px;" alt=""/>
                                </div>
                            </div>
                        </div>
                    </template>

                    <b-dropdown-header>
                        <header class="dropdown__header-inner">
                            <h4 class="heading4 text-break mr-4">Users in {{ info.name }}</h4>

                            <a v-if="false" href="#" class="link link--lg">Edit</a>
                        </header>

                        <ul class="rows-list">
                            <li  v-for="(permission, index) in info.permissions" :key="index">
                                <div class="rows-list__avatar">
                                    <Avatar
                                        :username="permission.name"
                                        :src="permission.avatar"
                                        :size="30">
                                    </Avatar>
                                </div>

                                <h5 class="heading5 heading5--secondary text-break">{{ permission.name }}</h5>

                                <!-- Please add here the logic first -->
                                <p class="ml-auto pl-2">{{ permission.role.name }}</p>
                                <a class="link-info" href="#">
                                    <span class="link-info__content">{{ permission.role.description }}</span>
                                </a>
                            </li>
                        </ul>

                        <a v-if="$store.state.user.company_id == constants.companyPfizer && hasReadOnlyAccess" @click="leaveTracker" class="leave-tracker">Leave Tracker</a>
                    </b-dropdown-header>
                </b-dropdown>

                <!--<a href="#" class="info-plate">Info & Manage</a>-->

                <div class="info-plate info-plate--updated">
                    <div class="info-plate__link" v-b-toggle.collapse-1 variant="primary">
                        Info & Manage

                        <b-dropdown v-if="info.can_edit" id="dropdown-1" text="Actions" class="info-plate__actions" variant="link" no-caret>
                            <b-dropdown-item @click="$refs.editTracker.open(id)" class="action action--edit">Edit tracker</b-dropdown-item>
                            <b-dropdown-item @click="$refs.duplicateTracker.open(id, info.name)" class="action action--edit">Duplicate tracker</b-dropdown-item>
                            <b-dropdown-item @click="$refs.editTask.open(0)" class="action action--task">Add task</b-dropdown-item>
                            <b-dropdown-item v-if="canEditInfo" @click="deleteTracker" class="action action--delete">Delete tracker</b-dropdown-item>
                            <b-dropdown-item v-if="false" class="action action--home">Make this tracker my homepage</b-dropdown-item>
                            <b-dropdown-item v-if="false" class="action action--save">Save this tracker as a template</b-dropdown-item>
                            <b-dropdown-item v-if="false" class="action action--pdf">Save as PDF</b-dropdown-item>
                            <b-dropdown-item v-if="false" class="action action--copy">Duplicate</b-dropdown-item>
                            <b-dropdown-item v-if="canEditInfo && info.status != 'archive'" @click="archiveTracker" class="action action--archive">Archive</b-dropdown-item>
                            <b-dropdown-item v-if="canEditInfo && info.status == 'archive'" @click="unarchiveTracker" class="action action--archive">Unarchive</b-dropdown-item>
                            <b-dropdown-item v-if="canEditInfo" @click="$refs.selectFolder.open()" class="action action--add">Add to Folder</b-dropdown-item>
                        </b-dropdown>

                        <!--<a href="#" class="info-plate__actions">Actions</a>-->
                    </div>

                    <b-collapse id="collapse-1" :visible="initStartupsCount == 0 || showActivityTab" class="info-plate__content">

                        <b-card no-body>
                            <b-tabs justified>
                                <b-tab title="Overview" active>
                                  <h5 class="heading5 heading5--secondary d-flex justify-content-between align-items-center mb-3">
                                    <span>{{info.name}}</span>

                                      <select :class="{'status-select--live': newStatus == 'live'}" v-if="info.type == 'public' && info.user_permissions.indexOf('tracker-change-status') >= 0" class="status-select" v-model="newStatus">
                                          <option :class="name" v-for="(name, key) in constants.trackerStatus" :key="key" :value="key">
                                              {{name}}
                                          </option>
                                      </select>
                                  </h5>

                                    <a v-if="info.type == 'public' && newStatus == 'live' && !info.only_referral" class="copy-link" @click="copyPublicLink">Copy Public Challenge Link</a>
                                    <a v-if="info.type == 'public' && newStatus == 'live' && info.only_referral" class="copy-link" @click="copyPublicLink">Copy Referral Challenge Link</a>
                                    <a v-if="$store.state.user.company_id == constants.companyPfizer" @click="copyInternalLink" class="copy-link" >Copy internal tracker link</a>
                                    <p><strong>Created:</strong> {{info.created}}</p>

                                    <template v-if="info.type == 'public' || info.status != 'draft'">
                                        <p><strong>Status:</strong> {{constants.trackerStatus[info.status]}}</p>
                                    </template>

                                    
                                    <template v-if="info.description">
                                      <p><strong>Description</strong></p>
                                      <div v-html="info.description" class="info-plate__description"></div>
                                    </template>

                                    <template v-if="info.start_date">
                                      <p><strong>Start Date:</strong> {{info.start_date}}</p>
                                    </template>

                                    <template v-if="info.end_date">
                                      <p><strong>End Date:</strong> {{info.end_date}}</p>
                                    </template>

                                    <template v-if="info.submitter_fields.length">
                                        <h5 class="heading5 heading5--secondary mt-4 mb-3">Details</h5>

                                        <div v-for="(field, index) in info.submitter_fields" :key="index" class="mb-4">
                                            <p><strong>{{field.field.name}}:</strong></p>

                                            <custom-field
                                                :field="info.submitter_fields[index].field"
                                                :value="info.submitter_fields[index].value"
                                                :editable="false"
                                                :disabled="true"
                                            >
                                            </custom-field>
                                        </div>
                                    </template>

                                    <template v-if="sharedEcosystems.length">
                                        <h5 class="heading5 heading5--secondary">Shared Ecosystems</h5>

                                        <ul class="rows-list mb-3">

                                            <li v-for="(ecosystem, index) in sharedEcosystems" :key="index" class="">
                                                <div class="image-block">
                                                    <img :src="LogoHelper.getLogo(ecosystem.logo)" alt="">
                                                </div>
                                                
                                                <div class="row-list__inner">
                                                    <h5 class="heading5 heading5--secondary">{{ ecosystem.name }}</h5>
                                                    <p>Added {{ecosystem.date}} by {{ecosystem.user}}</p>
                                                </div>

                                                <a @click="revokeShareEcosystem(ecosystem.id)" class="link-remove link" href="#">Remove</a>
                                            </li>
                                        </ul>
                                    </template>

                                    <div class="text-center" v-if="info.type == 'internal'">
                                        <button class="btn btn-bordered" @click="share">Add an Ecosystem</button>
                                    </div>
                                </b-tab>

                                <b-tab title="Updates" :active="showActivityTab">
                                    <div class="tasks-wrapper">
                                        <h4 class="heading4 d-flex">Tasks Assigned to
                                            <div class="tasks__select" v-click-outside="function() {openTasksTypeSelect = false}">
                                                <div @click="openTasksTypeSelect = true" class="tasks__select__chosen">
                                                    <span>{{taskListTypes[tasksListType]}}</span>
                                                </div>
                                                <ul v-show="openTasksTypeSelect">
                                                    <li v-for="(name, value) in taskListTypes"  :key="value" @click="tasksListType = value; openTasksTypeSelect = false">{{name}}</li>
                                                </ul>
                                            </div>
                                        </h4>
                                    
                                    
                                        <ul class="tasks-list">
                                            <li v-for="(task, index) in tasks" :key="index">
                                                
                                                <div class="tasks-list__inner">
                                                    <div>{{task.title}}</div>
                                                    <b-dropdown class="ml-5 drag-n-drop icons-list dropdown-simple dropdown-small" boundary="viewport">
                                                        <b-dropdown-item class="icons-list__edit" @click="editTask(task.id)">
                                                            Edit Task
                                                        </b-dropdown-item>
                                                        <b-dropdown-item class="icons-list__delete" @click="deleteTask(task.id)">
                                                            <font-awesome-icon :icon="['fa', 'trash']" />
                                                            Remove Task
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                                <div class="tasks-list__inner">
                                                    <div class="tasks-list__assignee" v-html="task.assignee"></div>
                                                    <time class="tasks-list__date" v-html="task.due"></time>
            
                                                    <taskStatus
                                                        :rowId="parseInt(task.id)"
                                                        :columnData="task.status"
                                                        v-on:action="changeTaskStatus"
                                                    >
                                                    </taskStatus>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    

                                    <pager v-if="tasks.length" :pages-count="tasksPagesCount" :init-page="tasksCurrentPage" v-on:changePage="changeTasksPage"></pager>

                                    <div class="comments">
                                        <div class="comment-form">
                                            <div class="comments__avatar">
                                                <Avatar
                                                    :username="$store.state.user.name"
                                                    :src="$store.state.user.avatar"
                                                    :size="30">
                                                </Avatar>
                                            </div>
                                            <form action="">
                                                <Mentionable
                                                    :keys="['@']"
                                                    :items="usersMentionList"
                                                    offset="6"
                                                    insert-space
                                                    placement="top-start"
                                                    @apply="mentionApplied = true"
                                                >
                                                    <template #item-@="{ item }">
                                                        <div class="user">
                                                            <Avatar
                                                                :username="item.name"
                                                                :src="item.avatar"
                                                                :size="25"
                                                            >
                                                            </Avatar>

                                                            <div class="mention-item__inner">
                                                                {{ item.value }}
                                                                <span class="dim">
                                                                    ({{ item.name }})
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <textarea v-model="newNote" class="comment-form__text" @keyup.enter="addNote"></textarea>
                                                </Mentionable>
                                            </form>
                                        </div>

                                        <div class="comments__item" v-for="(note, index) in notes" :key="index">
                                            <header class="comments__item__header">
                                                <div class="comments__avatar">
                                                    <Avatar
                                                        :username="note.user_name"
                                                        :src="note.user_avatar"
                                                        :size="30">
                                                    </Avatar>
                                                </div>
                                                <div class="comments__author" :class="{deleted: note.user_deleted}">{{ note.user_name }}<span v-if="note.user_deleted"> (D)</span></div>
                                                <time class="comments__date">{{ dateHelper.decodeDate(note.created_at) }}</time>
                                            </header>
                                            <div class="comments__item__content" v-html="note.text">
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab title="Filter">
                                    <h5 class="heading5 heading5--secondary">Startup name, Description, Keywords</h5>
                                    <div class="form-search"><input placeholder="Search for startup name, description or keywords" type="text" v-model="filters.search"></div>

                                    <h5 class="heading5 heading5--secondary mt-3">Filter by rating</h5>

                                    <div class="rating-section mb-3">
                                        <div class="rating">
                                            <span :class="{'rating__current': filters.rating >= 1}" @click="filters.rating = 1"></span>
                                            <span :class="{'rating__current': filters.rating >= 2}" @click="filters.rating = 2"></span>
                                            <span :class="{'rating__current': filters.rating >= 3}" @click="filters.rating = 3"></span>
                                            <span :class="{'rating__current': filters.rating >= 4}" @click="filters.rating = 4"></span>
                                            <span :class="{'rating__current': filters.rating >= 5}" @click="filters.rating = 5"></span>
                                        </div>
                                    </div>

                                    <ul class="list-input">
                                        <li class="input-radio mb-1">
                                            <input id="q0" type="radio" name="q11" :checked="filters.ratingCondition == ''" @click="filters.ratingCondition = ''">
                                            <label for="q0">No rating filter</label>
                                        </li>
                                        <li class="input-radio mb-1">
                                            <input id="q1" type="radio" name="q11" :checked="filters.ratingCondition == 'higher'" @click="filters.ratingCondition = 'higher'">
                                            <label for="q1">Show higher ratings</label>
                                        </li>
                                        <li class="input-radio">
                                            <input id="q2" type="radio" name="q11" :checked="filters.ratingCondition == 'lower'" @click="filters.ratingCondition = 'lower'">
                                            <label for="q2">Show lower ratings</label>
                                        </li>
                                    </ul>

                                    <h5 class="heading5 heading5--secondary mt-3">Tags</h5>
                                    <multiselect
                                        v-model="filters.tags"
                                        :multiple="true"
                                        placeholder="Select tags"
                                        :options="tagsList"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <h5 class="heading5 heading5--secondary mt-3">Categories</h5>
                                    <multiselect
                                        v-model="filters.categories"
                                        :multiple="true"
                                        placeholder="Select categories"
                                        :options="categoriesList"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <h5 class="heading5 heading5--secondary mt-3">Trackers</h5>
                                    <multiselect
                                        v-model="filters.trackers"
                                        :multiple="true"
                                        placeholder="Select trackers"
                                        :options="trackersList"
                                        select-label=""
                                        deselect-label=""
                                        label="name"
                                        track-by="name"
                                        class="multiselect-mid pl-2"
                                    >
                                    </multiselect>

                                    <h5 class="heading5 heading5--secondary mt-3">Startup Diligence Fields</h5>
                                    <a class="filters__list__link filters__custom filters__list__link--modal" @click="openCustomDataFilter">Select Diligence Fields</a>
                                    <div class="tags-simple-list" v-if="filters.fields.length">
                                        <div class="tags-simple-list__item" v-for="(field, index) in filters.fields" :key="index">
                                            {{customFieldsList[field.id].name}}: {{field.valueAlias}}
                                            <a @click="filters.fields.splice(index, 1)"><span class="tags-simple-list__item__close"></span></a>
                                        </div>
                                    </div>

                                    <h5 class="heading5 heading5--secondary mt-3">Curator</h5>
                                    
                                    <div class="input-checkbox--gray">
                                        <div class="input-checkbox">
                                            <input type="checkbox" id="added-by-me" v-model="filters.addedByMe">
                                            <label for="added-by-me"></label>
                                        </div>
                                        <label for="added-by-me">Show only startups added by me</label>
                                    </div>


                                </b-tab>

                            </b-tabs>
                        </b-card>

                    </b-collapse>
                </div>
            </div>

            <div class="tracker-list__actions">
                <div>
                    <template v-if="displayType == 'list' && startupsCount">
                        Show
                        <select v-model="pageLength" class="select-transparent">
                            <option value="1">1</option>
                            <option value="20">20</option>
                            <option value="50" v-if="startupsCount > 20">50</option>
                            <option value="100" v-if="startupsCount > 50">100</option>
                        </select>
                        entries of {{startupsCount}}
                    </template>
                </div>

                <ul class="actions-list">
                    <template v-if="selectedRows.length">
                        <li class="actions-list__remove" v-if="info.type == 'internal' && selectedRows.length && info.user_permissions.indexOf('tracker-startups-delete') >= 0"><a @click="removeStartups"><font-awesome-icon :icon="['fa', 'trash']" /> Remove From Tracker</a></li>
                        <li class="actions-lis__csv" v-if="selectedRows.length"><a @click="exportCSV"><font-awesome-icon :icon="['fa', 'file-csv']" /> Export CSV</a></li>
                        <li class="actions-lis__csv" v-if="selectedRows.length"><a @click="exportContacts"><font-awesome-icon :icon="['fa', 'file-csv']" /> Export contacts</a></li>
                    </template>
                    <template v-else>
                        <li class="actions-list__add" v-if="info.type == 'internal' && info.user_permissions.indexOf('tracker-startups-add') >= 0"><a @click="$refs.addStartups.open()">Add Startups</a></li>
                        <li class="actions-list__ecosystem" v-if="info.type == 'internal' && hasEditAccess"><a @click="share">Invite Ecosystems</a></li>
                        <li class="actions-list__edit" v-if="hasEditAccess"><a @click="openManageColumns">Edit Columns</a></li>
                    </template>


                    <li class="actions-list__add" v-if="!info.user_permissions.length && $store.state.user.company_id == constants.companyPfizer"><a @click="joinTracker">Join Tracker</a></li>
                </ul>

            </div>
            <div v-if="displayType == 'pipeline'" class="top-title">
                {{startupsCount}} Startup(s)
            </div>
            
            <div class="scroll-anchor"></div>
        
            <main class="main main--dark">

                <div class="content-tracker-board" v-if="displayType == 'pipeline'">

                    <div v-for="(stage, stageIndex) in pipelineStartups" :key="stageIndex" class="content-tracker-board__column">

                        <header class="content-tracker-board__title">
                            {{stage.name}} <span class="startups-cnt">({{stage.count}})</span>
                            <a href="#" v-if="false">+</a>
                        </header>

                        <draggable handle=".draggable" v-model="pipelineStartups[stageIndex].startups" group="startups" class="content-tracker-board__content">

                            <StartupPlate v-for="startup in stage.startups" :key="startup.id"
                                          :startup="startup"
                                          :draggable="startup.draggable"
                                          :addData="addCellData"
                                          :hasReviews="info.reviews_enabled == 1"
                                          v-on:editReview="editReview(startup.id)"
                                          v-on:showReviews="showReviews(startup.id)"
                                          v-on:showAnswers="showAnswers(startup.id)"
                                          v-on:cardClicked="showDetails(startup.id)"
                            >
                            </StartupPlate>

                        </draggable>
                    </div>

                </div>

                <div v-if="displayType == 'list' && listLoaded" class="content-tracker-list">
                    <Grid
                          :columns="columns"
                          :has-checkbox-column="true"
                          :data="startups"
                          :addCellData="addCellData"
                          :page-length="parseInt(pageLength)"
                          :total-rows-count="totalRowsCount"
                          :sort="sort"
                          :currentPage="currentPage"
                          v-on:changePage="changePage"
                          v-on:changeSort="changeSort"
                          v-on:selectedRowsChanged="changeSelectedRows"
                          v-on:selectAllResults="selectAllResults"
                          v-on:action="startupsListAction"
                    >
                    </Grid>

                    <div v-if="!allCount" class="start-startup">
                        <p v-if="info.type == 'internal'">Add startups to your tracker to get started</p>
                        <p v-if="info.type == 'public'">No Startups applied tracker yet</p>
                        <button v-if="info.type == 'internal'" class="btn btn-primary btn-lg" @click="$refs.addStartups.open()">+ Add Startups</button>
                    </div>

                </div>
            </main>
            </div>
        </div>

        <ManageColumns
            ref="manageColumns"
            tableType="tracker-startups"
            :tracker-id="id"
            v-on:changeColumns="getColumns"
        >
        </ManageColumns>

        <AddStartups
            ref="addStartups"
            :trackerId="id"
            v-on:startupsAdded="startupsAdded"
        >
        </AddStartups>

        <EditReview
            ref="editReview"
            id="tracker"
            v-on:reviewSaved="reviewsUpdated"
        >
        </EditReview>

        <Reviews
            ref="reviews"
            :trackerId="id"
            v-on:reviewSaved="reviewsUpdated"
        >
        </Reviews>

        <FunnelCardPopup
            :trackerId="parseInt(id)"
            v-on:editReview="editReview"
            v-on:showReviews="showReviews"
            v-on:removeStartup="removeStartup"
            v-on:changed="getList"
            ref="funnelCardPopup"
        >
        </FunnelCardPopup>

        <edit-tracker
            ref="editTracker"
            :folder-id="0"
            v-on:trackerSaved="getInfo(); getList(); getColumns(); getDiligenceFieldsForFilter()"
        >
        </edit-tracker>

        <duplicate-tracker
            ref="duplicateTracker"
        >
        </duplicate-tracker>

        <ViewAnswers
            v-if="info.type == 'public'"
            ref="viewAnswers"
        >
        </ViewAnswers>

        <PdfLayout
            ref="pdfLayout"
            :startups="[pdfData]"
        >
        </PdfLayout>

        <edit-task
            ref="editTask"
            :tracker-id="id"
            prefix="-tracker"
        >
        </edit-task>

        <select-folder
            ref="selectFolder"
            v-on:folderSelected="addToFolder"
        >
        </select-folder>

        <edit-description
            :id="id"
            ref="editDescription"
            v-on:descriptionChanged="descriptionChanged"
        >
        </edit-description>

        <shared-ecosystems
            :tracker-id="id"
            ref="sharedEcosystems"
            v-on:trackerShared="trackerShared"
        >
        </shared-ecosystems>

        <CustomDataFilter
            :filters-list="customFieldsList"
            ref="customDataFilter"
            v-on:updateCustomDataFilter="updateCustomDataFilter"
        >
        </CustomDataFilter>
    </div>
</template>

<script>

import Grid from "@/components/Grid"
import trackers from "@/services/trackers.service"
import trackersStartups from "@/services/trackers-startups.service"
import tags from "@/services/tags.service"
import grid from '@/mixins/grid'
import ManageColumns from '@/components/manage/ManageColumns.vue'
import AddStartups from "@/components/trackers/AddStartups"
import EditDescription from "@/components/trackers/EditDescription.vue"
import CustomField from "@/components/customFields/CustomField"
import StartupPlate from "@/components/trackers/StartupPlate"
import Reviews from "@/components/trackers/Reviews"
import ViewAnswers from "@/components/trackers/ViewAnswers"
import EditReview from "@/components/trackers/EditReview"
import FunnelCardPopup from "@/components/trackers/StartupCardPopup"
import draggable from 'vuedraggable'
import Avatar from "vue-avatar";
import editTracker from "@/components/trackers/EditTracker";
import sharedEcosystems from "@/components/trackers/SharedEcosystems";
import user from "@/services/user.service";
import PdfLayout from "@/components/startups/PdfLayout";
import exports from "@/services/exports.service";
import team from "@/services/team.service";
import EditTask from "@/components/tasks/EditTask";
import multiselect from "vue-multiselect";
import categories from "@/services/categories.service";
import selectFolder from "@/components/manage/SelectTrackerFolder";
import tasks from "@/services/tasks.service";
import pager from "@/components/TablePager";
import taskStatus from "@/components/customColumns/Status";
import Vue from "vue";
import CustomDataFilter from "@/components/manage/CustomDataFilter";
import DuplicateTracker from "@/components/trackers/Duplicate";
import {Mentionable} from "vue-mention";

  export default {
      components: {
          Grid,
          ManageColumns,
          AddStartups,
          CustomField,
          StartupPlate,
          draggable,
          Avatar,
          EditReview,
          Reviews,
          editTracker,
          ViewAnswers,
          PdfLayout,
          FunnelCardPopup,
          EditTask,
          multiselect,
          selectFolder,
          pager,
          taskStatus,
          EditDescription,
          sharedEcosystems,
          CustomDataFilter,
          DuplicateTracker,
          Mentionable,
      },

      mixins: [grid],

      data() {
          return {
              id: parseInt(this.$route.params.id),
              loaded: false,
              listLoaded: false,
              boardLoaded: false,
              errorMessage: "",
              tableColumnsType: 'tracker-startups',
              startups: [],
              startupsCount: 0,
              pipelineStartups: [],
              initPipelineStartups: [],
              hasPipeline: false,
              notes: [],
              tasks: [],
              columnsLoaded: false,
              groups: [],
              tagsList: [],
              categoriesList: [],
              trackersList: [],
              sharedEcosystems: [],
              initStartupsCount: null,

              displayType: 'pipeline',
              info: {
                  name: '',
                  description: '',
                  type: '',
                  created: "",
                  submitterFields: [],
                  user_permissions: [],
                  has_pipeline: false,
                  reviews_enabled: false,
                  can_edit: false,
                  only_referral: false,
                  referral_url: '',
              },

              nameEditMode: false,
              newName: "",
              newStatus: "",
              notWatchStatus: false,

              addCellData: {
                  tagsList: [],
                  trackerId: parseInt(this.$route.params.id),
                  trackerType: "",
                  userPermissions: "",
                  companyType: "startups",
              },

              newNote: "",
              pdfData: {},

              pageLength: 20,

              filters: {
                  search: "",
                  tags: [],
                  rating: 3,
                  ratingCondition: '',
                  categories: [],
                  trackers: [],
                  addedByMe: false,
                  fields: [],
              },

              customFieldsList: {},

              serverFilters: {
                  search: "",
                  tags: [],
                  rating: 3,
                  ratingCondition: '',
                  categories: [],
                  trackers: [],
                  fields: [],
                  addedByMe: false,
              },


              tasksListType: '',
              allCount: 0,
              openTasksTypeSelect: false,

              tasksCurrentPage: 1,
              tasksPageLength: 5,
              showCompletedTasks: false,
              tasksTotalRowsCount: 0,

              usersMentionList: [],
              mentionApplied: false,
              showActivityTab: false,
          }
      },

      watch: {
          displayType() {
              if (this.displayType == 'list' && !this.totalRowsCount) {
                  this.getColumns()
              }
          },

          pipelineStartups: {
              deep: true,
              handler() {

                  if (this.boardLoaded) {
                      let changed = []

                      for (let stage in this.pipelineStartups) {
                          let initStage = this.initPipelineStartups[stage]
                          let changedStartups = []

                          this.pipelineStartups[stage].startups.forEach(startup => {

                              if (!this.arrayHelper.exists(initStage.startups, 'id', startup.id)) {
                                  changedStartups.push(startup)
                              }
                          })

                          if (changedStartups.length) {
                              changed.push({
                                  id: initStage.id,
                                  startups: changedStartups,
                              })
                          }
                      }

                      if (changed.length) {
                          trackersStartups.savePipelineStartups(this.id, {pipeline: changed}).then(() => {
                              this.getPipelineStartups()
                              if (this.listLoaded) {
                                  this.getList()
                              }
                          })
                      }
                  }
              }
          },

          newStatus() {
              if (!this.notWatchStatus) {
                  this.updateStatus()
              }
          },

          filters: {
              deep: true,
              handler() {
                  this.serverFilters.search = this.filters.search
                  this.serverFilters.tags = this.arrayHelper.arrayColumn(this.filters.tags, 'value')
                  this.serverFilters.rating = this.filters.rating
                  this.serverFilters.ratingCondition = this.filters.ratingCondition
                  this.serverFilters.categories = this.arrayHelper.arrayColumn(this.filters.categories, 'value')
                  this.serverFilters.trackers = this.arrayHelper.arrayColumn(this.filters.trackers, 'value')
                  this.serverFilters.fields = this.filters.fields
                  this.serverFilters.addedByMe = this.filters.addedByMe
                  this.getList()
                  this.getPipelineStartups()
              }
          },

          tasksListType() {
              this.getTasks()
          }
      },

      computed: {
          canEditInfo() {
              return this.info.user_permissions.indexOf('tracker-edit') >= 0
          },

          taskListTypes() {
              let list = {}
              list['my'] = 'Me'

              if (this.$store.state.user.is_admin) {
                  this.groups.forEach(item => {
                      list['group-' + item.id] = item.name
                  })

                  list['all'] = 'Everyone'
              }
              else {
                  list['team'] = 'Teams'
              }

              return list
          },

          tasksPagesCount() {
              return  Math.ceil(this.tasksTotalRowsCount / this.tasksPageLength)
          },

          hasReadOnlyAccess() {
              if (this.$store.state.user.is_admin) {
                  return false
              }
              else {
                  let hasReadOnlyAccess = false
                  this.info.permissions.forEach(permission => {
                      if (permission.id == this.$store.state.user.id) {
                          if (permission.role.name == 'Read only') {
                              hasReadOnlyAccess = true
                          } else {
                              return false
                          }
                      }
                  })

                  return hasReadOnlyAccess
              }
          },

          hasEditAccess() {
              if (this.$store.state.user.is_admin) {
                  return true
              }
              else {
                  let hasEditAccess = false
                  this.info.permissions.forEach(permission => {
                      if (permission.id == this.$store.state.user.id) {
                          if (permission.role.name != 'Read only') {
                              hasEditAccess = true
                          } else {
                              return false
                          }
                      }
                  })

                  return hasEditAccess
              }
          },
      },

      mounted() {
          this.getInfo()
          this.getNotes()
          this.getSharedEcosystems()
          this.getTagsList()
          this.getDiligenceFieldsForFilter()
          this.getUsersMentionList()

          user.getTaskType(0, this.id).then(response => {
              this.tasksListType = response.data
          })

          this.$store.watch(state => {
              if (state.needUpdateStartups) {
                  this.getList()
                  this.getPipelineStartups()
              }
          })

          this.$store.watch(state => {
              if (state.needUpdateTasks) {
                  this.getTasks()
              }
          })

          team.getGroupsList().then(response => {
              this.groups = response.data
          })

          tags.getList().then(response => {
              this.tagsList = response.data
          })

          categories.getList().then(response => {
              this.categoriesList = response.data
          })

          trackers.getList().then(response => {
              this.trackersList = []
              response.data.forEach(item => {
                  if (item.value != this.id) {
                      this.trackersList.push(item)
                  }
              })
          })

          if (this.$route.query.activity) {
              this.showActivityTab = true
          }
      },

      methods: {
          getList() {
              if (this.columnsLoaded) {
                  let columns = this.arrayHelper.arrayColumn(this.columns, 'name')
                  let sort = this.sort
                  let filters = this.serverFilters
                  let currentPage = this.currentPage
                  let pageLength = this.pageLength

                  trackersStartups.getStartupsList(this.id, {
                      columns,
                      sort,
                      filters,
                      currentPage,
                      pageLength
                  }).then(response => {
                      this.startups = response.data.data
                      this.totalRowsCount = parseInt(response.data.total_count)
                      this.allCount = parseInt(response.data.all_count)
                      this.currentPage = response.data.current_page
                      this.listLoaded = true
                      this.startupsCount = this.totalRowsCount

                      if (this.initStartupsCount === null) {
                          this.initStartupsCount = this.startupsCount
                      }
                  })
              }
              else {
                  this.getColumns()
              }
          },

          getPipelineStartups() {
              if (this.hasPipeline) {
                  let filters = this.serverFilters

                  trackersStartups.getPipelineStartups(this.id, {filters}).then(response => {
                      let count = 0
                      this.pipelineStartups = response.data
                      this.initPipelineStartups = this.arrayHelper.cloneArray(response.data)

                      for (let i in this.pipelineStartups) {
                          count = count + this.pipelineStartups[i].startups.length
                      }

                      this.startupsCount = count

                      if (this.initStartupsCount === null) {
                          this.initStartupsCount = this.startupsCount
                      }

                      this.$nextTick(() => {
                          this.boardLoaded = true
                      })
                  })
              }
          },

          getInfo() {
              trackers.getInfo(this.id).then(response => {
                  this.info = response.data
                  document.title = this.info.name + ' | SwitchPitch'

                  this.displayType = response.data.default_view
                  this.loaded = true
                  this.notWatchStatus = true
                  this.newStatus = this.info.status

                  this.$nextTick(() => {
                      this.notWatchStatus = false
                  })

                  this.addCellData.trackerType = this.info.type
                  this.addCellData.userPermissions = this.info.user_permissions

                  if (response.data.pipeline_id) {
                      this.hasPipeline = true
                      this.getPipelineStartups()
                  }
                  else {
                      this.hasPipeline = false
                      this.displayType = 'list'
                  }

              }).catch(error => {
                  this.errorMessage = error.response.data.message
              })
          },

          getSharedEcosystems() {
              trackers.getSharedEcosystems(this.id).then(response => {
                  this.sharedEcosystems = response.data
              })
          },

          getNotes() {
              trackers.getNotes(this.id).then(response => {
                  this.notes = response.data
              })
          },

          getTagsList() {
              tags.getList().then(response => {
                  this.addCellData.tagsList = response.data
              })
          },

          getTasks(forExport = false) {
              let currentPage = this.tasksCurrentPage
              let pageLength = this.tasksPageLength
              let search = ""
              let showCompleted = this.showCompletedTasks

              tasks.getIndex(this.tasksListType, 0, this.id, {
                  forExport,
                  search,
                  showCompleted,
                  currentPage,
                  pageLength
              }).then(response => {
                  if (!forExport) {
                      this.tasks = response.data.data
                      this.tasksTotalRowsCount = parseInt(response.data.total_count)
                      this.tasksCurrentPage = response.data.current_page
                  }
                  else {
                      this.fileHelper.download(response.data, 'tasks.csv')
                  }
              })
          },

          getDiligenceFieldsForFilter() {
              trackers.getDiligenceFieldsForFilter(this.id).then(response => {
                  if (response.data.length) {
                      this.customFieldsList = response.data
                  }
              })
          },

          changeTasksPage(page) {
              this.tasksCurrentPage = page
              this.getTasks()
          },

          updateName() {
              let data = {
                  name: this.newName
              }

              trackers.update(this.id, data).then(() => {
                  this.info.name = data.name
                  this.getInfo()
                  this.nameEditMode = false
              })
          },

          updateStatus() {
              let data = {
                  status: this.newStatus
              }

              trackers.update(this.id, data).then(() => {
                  this.getInfo()
              })
          },

          openManageColumns() {
              this.$refs.manageColumns.open()
          },

          startupsAdded() {
              if (this.listLoaded) {
                  this.getList()
              }

              this.getPipelineStartups()
          },

          editReview(startupId) {
              this.$refs.editReview.open(this.id, startupId)
          },

          showReviews(startupId) {
              this.$refs.reviews.open(this.id, startupId)
          },

          reviewsUpdated() {
              this.getPipelineStartups()
              this.getList()
              this.$refs.funnelCardPopup.getData()
          },

          showAnswers(startupId) {
              this.$refs.viewAnswers.open(this.id, startupId)
          },

          showDetails(startupId) {
              this.$refs.funnelCardPopup.open(startupId)
          },

          archiveTracker() {
              trackers.update(this.id, {status: 'archive'}).then(() => {
                  this.info.status = 'archive'
              })
          },

          unarchiveTracker() {
              trackers.update(this.id, {status: 'draft'}).then(() => {
                  this.info.status = 'draft'
              })
          },

          getColumns() {
              this.columns = [],

                  user.getColumnsForTracker(this.id).then(response => {

                      let columns = response.data
                      this.columns = []

                      for (let i in columns) {
                          let column = columns[i]

                          if (columns[i].name == 'name') {
                              column.component = 'SearchCompanyNameColumn'
                          }

                          if (columns[i].name == 'location') {
                              column.component = 'SearchCompanyLocationColumn'
                          }

                          if (columns[i].name.indexOf('custom_') == 0 ||
                              columns[i].name.indexOf('diligence_') == 0 ||
                              columns[i].name.indexOf('question_') == 0) {
                              column.component = 'CustomField'
                          }

                          if (columns[i].name == 'reviews') {
                              column.component = 'ReviewsColumn'
                          }

                          if (columns[i].name == 'ecosystems') {
                              column.component = 'RawColumn'
                          }

                          if (columns[i].name == 'submission') {
                              column.component = 'Actions'
                          }

                          this.columns.push(column)
                      }

                      if (this.info.type == 'public') {
                          this.columns.push(
                              {
                                  name: 'actions',
                                  label: 'Actions',
                                  component: 'Actions',
                              }
                          )
                      }

                      this.columnsLoaded = true
                      this.getList()
                  })
          },

          addNote() {
              if (this.mentionApplied) {
                  this.$nextTick(() => {
                      this.mentionApplied = false
                  })
              }
              else if (this.newNote.length) {
                  let data = {
                      text: this.newNote
                  }

                  this.newNote = ""

                  trackers.addNote(this.id, data).then(() => {
                      this.getNotes()
                  })
              }
          },

          changeSelectedRows(ids) {
              this.selectedRows = ids
          },

          selectAllResults(result) {
              this.selectedAllResults = result
          },

          removeStartups() {
              if (this.selectedAllResults) {
                  if (confirm(this.totalRowsCount + " startup(s) will be removed from tracker. Do you want to proceed?")) {
                      trackersStartups.removeAllStartups(this.id).then(() => {
                          this.getList()
                          this.getPipelineStartups()
                      })
                  }
              }
              else {
                  if (confirm(this.selectedRows.length + " startup(s) will be removed from tracker. Do you want to proceed?")) {
                      trackersStartups.removeStartups(this.selectedRows, [this.id]).then(() => {
                          this.getList()
                          this.getPipelineStartups()
                      })
                  }
              }
          },

          removeStartup(id) {
              trackersStartups.removeStartups([id], [this.id]).then(() => {
                  this.getList()
                  this.getPipelineStartups()
              })
          },

          copyPublicLink() {
              let link
              if (this.info.only_referral) {
                  link = document.location.origin + '/public-trackers/' + this.info.referral_url
              }
              else {
                  link = document.location.origin + '/public-trackers/' + this.id
              }

              navigator.clipboard.writeText(link)
          },

          copyInternalLink() {
              let link = this.$api.defaults.baseURL;
              if (this.$store.state.user.company_id == this.constants.companyPfizer) {
                  link = link + '/pfizer-saml/login?returnTo=trackers/' + this.id;
              } else if(this.$store.state.user.company_id == this.constants.companyColgate){
                  link = link + '/colgate-saml/login?returnTo=trackers/' + this.id;
              } else {
                  link = document.location.origin + '/trackers/' + this.id
              }
              navigator.clipboard.writeText(link)
          },

          deleteTracker() {
              if (confirm("Delete tracker?")) {
                  trackers.delete(this.id).then(() => {
                      this.$router.push('/trackers')
                  })
              }
          },

          addToFolder(folder) {
              trackers.addToFolder(folder.id, [this.id]).then(() => {
                  Vue.notify({
                      group: 'app',
                      type: 'success',
                      duration: 5000,
                      text: "Tracker added to " + folder.name + " folder."
                  })
              })
          },

          startupsListAction(params) {
              if (params.action == 'diligence-field-changed') {
                  this.getPipelineStartups()
                  this.getList()
              }
              else if (params.action == 'show-reviews') {
                  this.showReviews(params.rowId)
              }
              else if (params.action == 'edit-review') {
                  this.editReview(params.rowId)
              }
              else if (params.action == 'view-answers') {
                  this.showAnswers(params.rowId)
              }
              else if (params.action == 'pdf') {
                  trackersStartups.getDataForPdf(this.id, params.rowId).then(response => {
                      this.pdfData = response.data
                      this.$refs.pdfLayout.generatePdf()
                  })
              }
          },

          exportCSV() {
              let result
              if (this.selectedAllResults) {
                  result = exports.exportAllStartupsFromTracker(this.id, this.columns)
              }
              else {
                  let startups = this.selectedRows
                  result = exports.exportStartupsFromTracker(this.id, startups, this.columns)
              }

              result.then(response => {
                  this.fileHelper.download(response.data, 'startups.csv')
              })
          },

          exportContacts() {
              let result
              if (this.selectedAllResults) {
                  result = exports.exportAllStartupsContactsFromTracker(this.id)
              }
              else {
                  let startups = this.selectedRows
                  result = exports.exportStartupsContactsFromTracker(this.id, startups)
              }

              result.then(response => {
                  this.fileHelper.download(response.data, 'contacts.csv')
              })
          },

          changeTaskStatus(params) {
              let status = params.status
              tasks.update(params.rowId, {status: status}).then(() => {
                  this.getTasks()
              })
          },

          editTask(id) {
              this.$refs.editTask.open(id)
          },

          deleteTask(id) {
              if (confirm('Remove task?')) {
                  tasks.delete(id).then(() => {
                      this.getTasks()
                  })
              }
          },

          share() {
              if (!this.info.description) {
                  this.$refs.editDescription.open()
              }
              else {
                  this.$refs.sharedEcosystems.open()
              }
          },

          revokeShareEcosystem(id) {
              if (confirm("Revoke Ecosystem Access?")) {
                  trackers.revokeShareWithEcosystems(this.id, id).then(() => {
                      this.getSharedEcosystems()
                  })
              }
          },

          descriptionChanged(description) {
              trackers.update(this.id, {description: description}).then(() => {
                  this.info.description = description
                  this.share()
              })
          },

          trackerShared(count) {
              this.getSharedEcosystems()

              Vue.notify({
                  group: 'app',
                  type: 'success',
                  duration: 5000,
                  text: "Tracker shared with " + count + " ecosystem(s)"
              })
          },

          openCustomDataFilter() {
              this.$refs.customDataFilter.open()
          },

          updateCustomDataFilter(filters) {
              this.filters.fields = filters
          },

          getUsersMentionList() {
              team.getUsersMentionList().then(response => {
                  this.usersMentionList = response.data
              })
          },

          joinTracker() {
              trackers.join(this.id).then(response => {
                  if (response.data == 1) {
                      this.getInfo()
                  }
                  else {
                      alert("Default 'Read Only' role not found")
                  }
              })
          },

          leaveTracker() {
              trackers.leave(this.id).then(response => {
                  if (response.data == 1) {
                      this.getInfo()
                  }
                  else {
                      alert("'Read Only' role not found")
                  }
              })
          },
      }

  }
</script>